import { axios } from 'utils';
import BillingProcess from './billingProcess';
import ItemsService from './items';
import MachineService from './machine';
import MedicalService from './medical';
import RegisterService from './register';
import UserService from './user';

export const userService = new UserService(axios);
export const registerService = new RegisterService(axios);
export const itemService = new ItemsService(axios);
export const medicalService = new MedicalService(axios);
export const billingProcessService = new BillingProcess(axios);
export const machineService = new MachineService(axios);
